<template>
    <div :id="'container-' + id">
        <b-form-group class="app-input-scan" :id="'fieldset-' + id" v-bind="$attrs">
            <template v-slot:label>{{ labelStr }} <span v-if="isRequired" class="required"></span></template>
            <b-input-group class="input-scan-group" :id="'input-group-' + id" v-if="!waitInputScan">
                <b-form-input :ref="'ref-input-' + id" :id="'input-' + id" v-bind="$attrs" v-model="inputModel" @keyup="keyupAction" @keyup.enter="enterAction" @blur="blurAction"></b-form-input>
                <b-input-group-append>
                    <b-button variant="light" class="btn-open-camera" v-b-modal="'scan-barcode-' + id"><b-icon-upc-scan /></b-button>
                    <b-button v-if="showTriggerButton" variant="primary" size="sm" @click="enterAction">{{ triggerButtonTitle }}</b-button>
                </b-input-group-append>
                <b-overlay :show="isBusy" no-wrap spinner-small spinner-type="grow"></b-overlay>
            </b-input-group>
            <b-input-group class="input-scan-group" :id="'input-group-waiting' + id" v-if="waitInputScan">
                <b-form-input :ref="'ref-input-' + id" :id="'input-wait-' + id" v-bind="$attrs" v-model="valueInputed" :disabled="true"></b-form-input>
                <b-input-group-append>
                    <b-button variant="light" class="btn-clear-input" @click="clearDataMethod"><b-icon-trash-fill /></b-button>
                    <b-button v-if="showTriggerButton" variant="primary" size="sm" @click="enterAction">{{ triggerButtonTitle }}</b-button>
                </b-input-group-append>
                <b-overlay :show="isBusy" no-wrap spinner-small spinner-type="grow"></b-overlay>
            </b-input-group>
            <b-form-invalid-feedback id="input-name-live-feedback" :state="state">
                {{ errorMessage }}
            </b-form-invalid-feedback>
        </b-form-group>
        <b-col cols="12">
            <b-modal hide-footer :id="'scan-barcode-' + id" :ref="'ref-input-' + id" class="app-input-scan" @ok="saveBarcodeText" @hidden="resetScanner" title="Scanner">
                <div v-if="!isScanned">
                    <StreamBarcodeReader
                    @decode="(a, b, c) => onDecode(a, b, c)"
                    @loaded="() => onLoaded()"
                    ></StreamBarcodeReader>
                    {{ scannedBarcode }}
                </div>
                <div v-if="isScanned">
                    <div class="barcode-text">{{ scannedBarcode }}</div>
                    <div class="text-center">
                        <b-button variant="warning" @click="resetScanner()">Scan Ulang</b-button>
                    </div>
                </div>
            </b-modal>
        </b-col>
    </div>
</template>
<script>
import { StreamBarcodeReader } from "vue-barcode-reader";
export default {
    components: {StreamBarcodeReader},
    props: ["id", "model", "state", "errorMessage", "scannedMethod", "blurMethod", "label", "isRequired", "showTriggerButton", "triggerButtonTitle", "isBusy","waitInputScan","clearMethod"],
    data() {
        return {
            labelStr: this.label,
            scannedBarcode: "",
            isScanned: false,
            inputModel: this.model,
            valueInputed :''
        }
    }, 
    methods: {
        onDecode(a, b, c) {
            this.scannedBarcode = a;
            //this.isScanned = true;
            this.saveBarcodeText();
        },
        saveBarcodeText() {
            this.inputModel = this.scannedBarcode;
            this.$emit('update:model', this.inputModel);
            this.$bvModal.hide("scan-barcode-" + this.id);
            //this.$emit('change');
            this.enterAction();
            this.resetScanner();
        },
        enterAction() {
            this.$emit("scannedMethod");
        },
        keyupAction() {
            this.$emit('update:model', this.inputModel);
            this.valueInputed = this.inputModel;
        },
        clearDataMethod() {
            this.$emit("clearMethod");
        },
        blurAction() {
            this.$emit("blurMethod");
        },
        resetScanner() {
            this.scannedBarcode = "";
            this.isScanned = false;
        },
        onLoaded() {
            console.log("load");
        },
    },
    watch : {
        model : function(val) {
            this.inputModel = val;
        },
        label : function(val) {
            this.labelStr = val;
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .modal-dialog {
    height: 70vh;
    width: 60vh;
}

.input-scan-group {
    border: 1px solid var(--input-border-color);
    border-radius: 5px;

    .form-control {
        border: none !important;
    }
}

.input-group-text {
    font-size: 0.7rem !important;
}
.btn-open-camera {
    padding: 1px 6px !important;
}
.barcode-text {
    font-size: 2rem;
    text-align: center;
}
</style>